import { CmsActivityCategoryContainerModel } from '../../../../../../models/aggregates/cms/activity';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({
    providedIn: 'root'
})
export class CmsActivityCategoryService extends BaseApiPublicLoginTemplateService<CmsActivityCategoryContainerModel, CmsActivityCategoryContainerModel, CmsActivityCategoryContainerModel> {

    static readonly ACTIVITY_CATEGORY_SUB_PATH = 'activity-categories/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + CmsActivityCategoryService.ACTIVITY_CATEGORY_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + CmsActivityCategoryService.ACTIVITY_CATEGORY_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP
        this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + CmsActivityCategoryService.ACTIVITY_CATEGORY_SUB_PATH + BaseApiPublicLoginTemplateService.PUBLIC_EP
        this.httpClient = http;
    }
}